// extracted by mini-css-extract-plugin
export default {"page":"vff3Fg5kil9b8_wxkaNc","selectOrganization":"L98Gm0YqBs2mTUOtvGJB","controls":"pcjNGuJhmPEv_XkIDN0J"};